import { gql } from '@/utils/graphql';

import { imagefragment } from './image';

export const cardCalendarFragment = gql`
	fragment cardCalendarFragment on EventDate {
		state
		date
		location {
			name
		}
		uri
		uriLabel
		isFree
		availabilityDate
		availabilityLevel
		event {
			id: databaseId
			uptitle
			title(format: RENDERED)
			startDate
			endDate
			acf: eventCustomFields {
				specialMention
				isEvent
				isAroundTheShow
				hasDetailPage
				ticketLink
				ticketButtonText
				duration
				card {
					label {
						title
						text
					}
				}
				publics: publicCardCalendar {
					nodes {
						... on Public {
							id: databaseId
							title: name
							icon: publicCustomFields {
								img: icon {
									node {
										...imageFragment
									}
								}
							}
						}
					}
				}
				production: relatedProductions {
					nodes {
						... on Production {
							id: databaseId
						}
					}
				}
			}
			link
			image: featuredImage {
				node {
					...imageFragment
				}
			}
			excerpt(format: RENDERED)
			genres {
				nodes {
					translation(language: $language) {
						id: slug
						name
					}
				}
			}
			thematics {
				nodes {
					translation(language: $language) {
						id: slug
						name
						description
						acf: thematicCustomFields {
							link
						}
					}
				}
			}
			seasons {
				nodes {
					translation(language: $language) {
						id: slug
						name
					}
				}
			}
		}
	}
	${imagefragment}
`;
